import React from "react";
import { Button } from "./ui/button";
import { Plus, Sparkles } from "lucide-react";

export default function NoProjectState({ onCreate }) {
  const trigger = () => {
    const el = document.querySelector('[data-testid="project-switcher-trigger"]');
    if (el) el.click();
    if (onCreate) onCreate();
  };
  return (
    <div className="min-h-[70vh] grid place-items-center p-6" data-testid="no-project-state">
      <div className="max-w-md text-center">
        <div className="h-16 w-16 rounded-2xl bg-emerald-500/15 text-emerald-400 grid place-items-center mx-auto mb-5">
          <Sparkles className="h-8 w-8" />
        </div>
        <h1 className="text-2xl font-extrabold text-white mb-2">Lege dein erstes Projekt an</h1>
        <p className="text-slate-400 text-sm mb-6">
          Alles in diesem System — Produkte, Leads, Deals, Skills, Beiträge, Berichte — ist nach Projekten getrennt.
          Starte mit deinem ersten Projekt (z. B. „Handyman Plan Werbung").
        </p>
        <Button className="bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-semibold" onClick={trigger} data-testid="no-project-create">
          <Plus className="h-4 w-4 mr-2" /> Neues Projekt
        </Button>
      </div>
    </div>
  );
}
